module.exports = __webpack_public_path__ + "img/cate1.bb6fa8d0.png";